import EditUserButton from './edit-user-button.jsx'
import CreateUserButton from '@BUP/pages/MySchoolPage/Students/studentByCourse/create-user-button.jsx'
import styles from './table-columns.module.scss'

export const getStudentAndParentsTableColumns = ({
  i18n,
  selectedCourse,
  courseRegistrations,
  getRegistrations,
  isActiveSurvey,
  courses,
  getUsersList,
  canWrite = true
}) => {
  const readColumns = [
    {
      title: i18n.t('common.resources.user.attributes.name.label'),
      dataIndex: 'name',
      align: 'center'
    },
    {
      title: i18n.t('common.resources.user.attributes.email.label'),
      dataIndex: 'email',
      align: 'center'
    }
  ]

  // FINANCE (read-only): drop the edit and create-password columns entirely.
  if (!canWrite) return readColumns

  const writeColumns = [
    {
      title: i18n.t('pages.MySchool.editUser'),
      dataIndex: 'actions',
      align: 'center',
      render: (info, user) => {
        if (!user) return <p>No user</p>
        return (
          <div className={styles.button_wrapper}>
            <EditUserButton
              selectedCourse={selectedCourse}
              user={user}
              courseRegistrations={courseRegistrations}
              getRegistrations={getRegistrations}
              isActiveSurvey={isActiveSurvey}
              courses={courses}
              getUsersList={getUsersList}
            />
          </div>
        )
      }
    },
    {
      title: i18n.t('common.resources.user.actions.create.password.submit').toUpperCase(),
      dataIndex: 'action',
      align: 'center',
      render: (info, user) => {
        if (!user) return <p>No user</p>
        return (
          <div className={styles.button_wrapper}>
            <CreateUserButton user={user} />
          </div>
        )
      }
    }
  ]

  return [...readColumns, ...writeColumns]
}
